import { useState } from 'react';
import type { Maybe } from '@soundxyz/utils';
import { GetCollectedReleasesNftCountDocument, gql, useQuery } from '@graphql/reactQuery';
import { useSubscribeReleaseCollector } from './useSubscribeRelease';

/*#__PURE__*/ gql(/* GraphQL */ `
  query GetCollectedReleasesNftCount($userId: UUID!, $releaseId: UUID!) {
    user(id: $userId) {
      id
      collectedReleases(pagination: { first: 1 }, filter: { releaseIds: [$releaseId] }) {
        edges {
          node {
            id
            nftsCount
          }
        }
      }
    }
  }
`);

export const useGetNumReleaseEditionsOwned = ({
  user,
  releaseId,
}: {
  user: Maybe<{
    id: string;
    publicAddress: string;
  }>;
  releaseId: string;
}) => {
  const [count, setCount] = useState(0);

  const { isLoading } = useQuery(GetCollectedReleasesNftCountDocument, {
    variables: !!user && {
      userId: user.id,
      releaseId,
    },
    onSuccess(userData) {
      setCount(userData?.data.user?.collectedReleases.edges[0]?.node.nftsCount ?? 0);
    },
    staleTime: 0,
  });

  useSubscribeReleaseCollector({
    releaseId,
    onData({ data: { releaseCollectorUpdates } }) {
      if (releaseCollectorUpdates.userPublicAddress !== user?.publicAddress) return;

      // When releaseCollectorUpdates.collector is null, it means the user stopped being a collector, so 0 nfts count is valid
      setCount(releaseCollectorUpdates.collector?.nftsCount ?? 0);
    },
    enabled: !!user,
  });

  return {
    isLoading,
    count,
  };
};
